import { EstateResultItem_OneViewBankruptcyInput } from 'queries';

import Asset from './asset';

type Props = {
  id: string;
  showAssetBtn: boolean;
  bankruptcy: EstateResultItem_OneViewBankruptcyInput;
  title: string;
};

export default function BankruptcyAsset({ id, showAssetBtn, bankruptcy, title }: Props) {
  return (
    <Asset
      key={id}
      id={id}
      showAssetBtn={showAssetBtn}
      itemData={[
        { field: 'Institution', value: bankruptcy.customerNumber },
        { field: 'Case Number', value: bankruptcy.caseNumber },
        { field: 'Date Filed', value: bankruptcy.dateFiled },
        { field: 'Date Reported', value: bankruptcy.dateReported },
        { field: 'Type', value: bankruptcy.type },
        { field: 'Filer', value: bankruptcy.filerCode },
        { field: 'Status', value: bankruptcy.status },
      ]}
      title={title}
    />
  );
}
